import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Close.svg",
  "use": "Close.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Close.svg\"><path d=\"m47.4142 47.4355a2.0012 2.0012 0 0 1 -2.8307 0l-12.6-12.6-12.5884 12.5891a2.0016 2.0016 0 0 1 -2.8306-2.8307l12.5888-12.5887-12.5865-12.5865a2.0015 2.0015 0 0 1 2.83-2.8305l12.587 12.5864 12.5975-12.5974a2.0015 2.0015 0 1 1 2.83 2.8306l-12.5968 12.5974 12.6 12.6a2.001 2.001 0 0 1 -.0003 2.8303z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol